import { AvailableComponents } from "./Components";

export default function Price({ config }) {
  const color =
    config.variant === "LIGHT" ? "var(--color-light)" : "var(--color-dark)";

  return (
    <div className="price">
      <h2
        style={{
          color,
        }}
      >
        {config.title}
      </h2>
      <h3
        style={{
          color,
        }}
        className="price-row"
      >
        {formatCurrencyBRL(config.price)}{" "}
        <p
          style={{
            color,
          }}
        >
          /{formatInterval(config.interval)}
        </p>
      </h3>

      <AvailableComponents.BUTTON
        config={{
          variant: config.variant,
          text: config.cta,
          redirect: config.redirect,
        }}
      />
    </div>
  );
}

const formatCurrencyBRL = (value) => {
  return new Intl.NumberFormat("pt-BR", {
    style: "currency",
    currency: "BRL",
    minimumFractionDigits: 2,
  }).format(value);
};

const formatInterval = (interval) => {
  return {
    week: "Semana",
    month: "Mês",
    bimonthly: "Bimestre",
    quarterly: "Trimestre",
    semiannual: "Semestral",
    year: "Ano",
  }[interval];
};
